import { createAction } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import { store } from "../../../../store";
import {
    isEditParkingRatesInProgress,
    setCurrentBatch,
    setHighlightedMapLayersData,
    setSegmentsToBeCreated,
    setSelectedAssetIds,
    setSelectedPolygonAssetIds,
    storeBatchLinks,
    storeBatchShapes,
    storeToBeConfirmedCustomGroupSegments,
    toggleBatchSelection,
    toggleCreateOptionsPanel,
    toggleCreatePolygonAssetPanel,
    toggleCreateRegulationPanel,
    toggleEditAssetPanel,
    toggleEditBatchSelection,
    toggleEditOptionsPanel,
    toggleEditParkingRatesOptionsPanel,
    toggleEditPolygonAssetPanel,
    toggleEditRegulationPanel,
    toggleFetchRegulationPanel,
    toggleProjectPanel
} from "../../../../actions";
import {
    MANAGER_MAP_VIEW_ROUTE,
    MANAGER_LIST_VIEW_ROUTE,
    ANALYZER_MAP_VIEW_ROUTE,
    ANALYZER_LIST_VIEW_ROUTE,
    ANALZER_DASHBOARD_VIEW_ROUTE
} from "../../../../constants";
import { defaultHighlightedMapLayersData } from "../../../../actions/Map/types";

export type RouteType = "map" | "list" | "dashboard";

export type ParentRouteType = "manager" | "analyzer";

export type RouteNames = { map: string; list: string; dashboard?: string; parent: ParentRouteType };

export function getRouteNames(type: ParentRouteType): RouteNames {
    if (type === "manager") {
        return {
            list: MANAGER_LIST_VIEW_ROUTE,
            map: MANAGER_MAP_VIEW_ROUTE,
            parent: type
        };
    }

    return {
        dashboard: ANALZER_DASHBOARD_VIEW_ROUTE,
        list: ANALYZER_LIST_VIEW_ROUTE,
        map: ANALYZER_MAP_VIEW_ROUTE,
        parent: type
    };
}

export const RESET_STATE = "RESET_STATE";

export interface ResetStateAction {
    type: typeof RESET_STATE;
}

export const resetStateRTK = createAction<ResetStateAction>(RESET_STATE);

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export const resetState = () => ({
    type: RESET_STATE
});

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const closeAllRightPanels = () => {
    const { dispatch } = store;

    toast.dismiss();
    dispatch(toggleCreateOptionsPanel({ isCreateOptionsPanelOpen: false }));
    dispatch(toggleEditOptionsPanel({ isEditOptionsPanelOpen: false }));
    dispatch(toggleBatchSelection({ isEnabled: false }));
    dispatch(toggleCreateRegulationPanel({ isCreateRegulationPanelOpen: false }));
    dispatch(toggleEditAssetPanel({ isEditAssetPanelOpen: false }));
    dispatch(toggleEditPolygonAssetPanel({ isEditPolygonAssetPanelOpen: false }));
    dispatch(toggleCreatePolygonAssetPanel({ isCreatePolygonAssetPanelOpen: false }));
    dispatch(toggleEditParkingRatesOptionsPanel({ isOpen: false }));
    dispatch(toggleEditBatchSelection({ isEditBatchSelectionEnabled: false }));
    dispatch(toggleFetchRegulationPanel({ isFetchRegulationPanelOpen: false }));
    dispatch(isEditParkingRatesInProgress({ inProgress: false }));
    dispatch(setCurrentBatch({ currentBatch: null }));
    dispatch(storeBatchShapes({ batchShapes: {} }));
    dispatch(storeBatchLinks({ batchLinks: {} }));
    dispatch(
        toggleEditRegulationPanel({
            isEditRegulationPanelOpen: false,
            regulationId: -1
        })
    );

    // Dispatch(toggleScenarioPanel({ isScenarioPanelOpen: false }));
    dispatch(toggleProjectPanel({ isProjectPanelOpen: false }));
    dispatch(
        setHighlightedMapLayersData({ highlightedMapLayersData: defaultHighlightedMapLayersData })
    );
    dispatch(setSelectedAssetIds({ selectedIds: [] }));
    dispatch(setSelectedPolygonAssetIds({ selectedPolygonIds: [] }));
    dispatch(setSegmentsToBeCreated({ segmentsToBeCreated: {} }));
    dispatch(
        storeToBeConfirmedCustomGroupSegments({ toBeConfirmedCustomGroupSegments: new Map() })
    );
};

export const resetColumnsFromLocalStorage = () => {
    localStorage.removeItem("selectedRegulationColumns");
    localStorage.removeItem("selectedAssetColumns");
    localStorage.removeItem("selectedWorkOrderColumns");
    localStorage.removeItem("selectedBatchColumns");
    localStorage.removeItem("selectedParkingRateColumns");
};
